import './UnstyledTextInput-8270f063.css';

var styles = {"Input":"prc-components-Input-Ic-y8"};

export { styles as default };
